
export default [
  {
  path: '/ticket_info',
  name: 'ticketInfo',
  component: () => import('@/views/appManage/ticket_info.vue'),
  props: true, // 允许通过 props 传递参数

} ,
{
    path: '/tcp_info',
    name: 'tcpInfo',
    component: () => import('@/views/appManage/tcp_info.vue'), // 这个是指向不同的组件
    props: true, // 允许通过 props 传递参数
  },

  {
    path: '/frame_info',
    name: 'frameInfo',
    component: () => import('@/views/appManage/frame_info.vue'), // 这个是指向不同的组件
    props: true, // 允许通过 props 传递参数
  },
];